<label
  *ngIf="item"
  [class.disable]="isDisabled"
  class="checkbox-item">
  <input
    (change)="checkChange(item)"
    [(ngModel)]="item.state"
    [disabled]="isDisabled"
    type="checkbox"
    class="checkbox-item__input" />
  <span class="checkbox-item__icon"></span>
  <span

    class="checkbox-item__name">
    <ng-container *ngIf="item.name">
      {{ (isLocalized ? "" : "CHECKBOX.") + item.name | translate }}
    </ng-container>
    <ng-container *ngIf="!item.name">
      {{ "CHECKBOX.BILL_NUMBER" | translate}} {{item.id}}
    </ng-container>
  </span>

</label>
